import { FadeIn } from "@/components/FadeIn";

export default function Hero({ onCta, onExample }) {
  return (
    <section id="top" className="relative pt-40 pb-16 md:pt-56 md:pb-20 overflow-hidden">
      {/* Background image - warm morning light on paper with pen */}
      <div className="absolute inset-0 -z-10">
        <img
          src="https://images.unsplash.com/photo-1455390582262-044cdead277a?w=1920&q=80"
          alt="Warmes Morgenlicht auf Papier und Feder — ein stiller Moment zum Schreiben einer persönlichen Trauerrede"
          className="w-full h-full object-cover opacity-[0.55]"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-cream/10 via-cream/25 to-cream" />
      </div>

      <div className="max-w-5xl mx-auto px-6 md:px-12">
        <FadeIn>
          <p className="label-eyebrow mb-8" data-testid="hero-eyebrow">Oratiorede · Trauerrede-Entwurf</p>
        </FadeIn>

        <FadeIn delay={0.1}>
          <h1
            data-testid="hero-headline"
            className="font-serif text-5xl sm:text-6xl md:text-7xl leading-[1.05] tracking-tight text-charcoal max-w-4xl"
          >
            Ein letztes Wort.
            <br />
            <span className="italic text-umber candle-flicker">Persönlich. Würdevoll.</span>
          </h1>
        </FadeIn>

        <FadeIn delay={0.2}>
          <p
            data-testid="hero-subtext"
            className="mt-10 text-xl md:text-[22px] leading-relaxed text-ink max-w-2xl font-serif"
          >
            Kein Ersatz für ein gesprochenes Wort. Ein stiller Rahmen, in dem Ihre Erinnerungen
            ihre Ordnung finden — als Ausgangspunkt für die Worte, die für sie bei diesem Abschied zählen.
          </p>
        </FadeIn>

        <FadeIn delay={0.3}>
          <div className="mt-12 flex flex-col sm:flex-row gap-4">
            <button onClick={onCta} data-testid="hero-cta-primary" className="btn-primary">
              Entwurf erstellen
            </button>
            <button onClick={onExample} data-testid="hero-cta-secondary" className="btn-secondary">
              Beispiel lesen
            </button>
          </div>
        </FadeIn>
      </div>
    </section>
  );
}
